/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'brand/NG_AGES_3-5': {
    width: 16,
    height: 16,
    viewBox: '0 0 52.74 131.75',
    data: '<path pid="0" _fill="currentColor" d="M2.33 25.53c-.36-6.83 3.75-14.9 8.83-19.34C14.87 2.97 18.73.37 23.63.04c4-.3 11.39.82 14.9 2.77 5.25 2.9 6.71 5.53 9.78 10.61 4 6.66 1.05 19.92-4.94 24.83-7.24 5.94-17.24 10.89-26.14 6.28-6.36-3.29-14.5-11.39-14.9-19zm48.15 64.11a28.78 28.78 0 0 1-5.82 5.63c-4.19 3.33-5.51 3.36-5.88 8.75-.39 5.72.08 11.35.08 17.08 0 4.51 1.05 9-4 10.12-4 .87-8.8.45-13 .27-2.87-.12-6.85-.44-9.09-2.57-2.74-2.59-1.32-8.45-1.32-11.86 0-3.62-.27-7.09-.27-10.68 0-2.8.91-6-1.1-8.34-1.7-2-4.66-2.39-6.48-4.33-3.81-4.06-3-10.64-3-15.76 0-4.63-1.59-11.42.51-15.76a26.68 26.68 0 0 1 3.51-5.89c3.05-3.46 8.25-2.83 12.31-2.86 4.83 0 9.7 0 14.63.13l1.92.07c4.51.17 9.9-.63 13.71 2.26 5.41 4.11 5 10.12 5.18 16.26.13 5.51 1.5 12.58-1.89 17.49zm-16.34-1.07c-1.55-.9-4.82-.83-6.56-.92s-3.64-.4-5.47-.5c-1.49-.08-3.48-.31-4.83.46-2.35 1.32-2.74 4.84-2.22 7.21.58 2.63 0 6.31 1.72 8.55s10.81 1.52 13.73 1.1c5.1-.74 5.1-5.4 5.32-9.8.12-2.57.56-4.79-1.69-6.1z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/brand/NG_AGES_3-5.js